import React from 'react'
import logo from "../../assets/ESPOL-GTSI-MR.svg";
import "../../css/Header.css"
import { Link } from "react-router-dom";

const Header = (props) => {
    return (
        <div className="header">
            <div className="container">
                <div className="row">                
                    <div className="col-12 col-sm-6 col-lg-4">
                        <Link className="link" to="/Inicio">
                            <img className='logo-header' src={logo} alt="Logo espol" ></img>
                        </Link>
                    </div>
                    {props.ifShowTime &&(
                        <div className="col-8 col-sm-6 col-lg-4 contador_creacion_cuenta">
                            <p>La sesión expira en: {props.tiempoRestante}</p>
                        </div>
                        )
                    }
                </div>
                <br />             
            </div>
        </div>
    )
}

export default Header;